module.exports = __webpack_public_path__ + "static/x52-2bc88788f4d4931235bb94a9407e69e8.png";